import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteConfigContext = createContext();

const DEFAULT_CONFIG = {
    hero_title: 'MMD GLOBAL ENTERPRISE',
    hero_subtitle: 'Connecting quality to the world',
    mission_text: '',
    vision_text: '',
    coordonnees_telephone: '+221 76 846 20 40',
    coordonnees_email: 'contact@mmd-global.com',
    coordonnees_adresse: 'Dakar, Sénégal',
    logo_global: 'https://customer-assets.emergentagent.com/job_mmd-global/artifacts/84lvvojb_WhatsApp%20Image%202026-03-25%20at%2021.12.59.jpeg',
    logo_luxury: 'https://customer-assets.emergentagent.com/job_mmd-global/artifacts/bdavqbk4_WhatsApp%20Image%202026-03-25%20at%2021.15.42.jpeg',
    global_title: 'Matériel de Bureau',
    global_subtitle: 'MMD Global',
    global_description: 'Bureaux, fauteuils, imprimantes et accessoires de qualité professionnelle.',
    luxury_title: 'Voitures de Luxe',
    luxury_subtitle: 'MMD Luxury Cars',
    luxury_description: 'Importation de véhicules haut de gamme des meilleures marques mondiales.'
};

export function SiteConfigProvider({ children }) {
    const [config, setConfig] = useState(DEFAULT_CONFIG);
    const [loading, setLoading] = useState(true);

    const fetchConfig = async () => {
        try {
            const response = await axios.get(`${API}/config`);
            setConfig({ ...DEFAULT_CONFIG, ...response.data });
        } catch (error) {
            console.error('Error fetching site config:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConfig();
    }, []);

    return (
        <SiteConfigContext.Provider value={{ config, loading, refetch: fetchConfig }}>
            {children}
        </SiteConfigContext.Provider>
    );
}

export const useSiteConfig = () => {
    const context = useContext(SiteConfigContext);
    if (!context) {
        throw new Error('useSiteConfig must be used within a SiteConfigProvider');
    }
    return context;
};
